import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import { ContactPrefix } from "@utils/BasicTypes";
import useDebugInformation from "../../hooks/useDebugInformation";
import { ui } from "../../interfaces/interfaces";
import { Paper } from "@mui/material";
import { useAppSelector } from "@store/hooks";

const name = "ContactSwitch"

type Props = {
  prefix: Exclude<ContactPrefix, "PropertyContact" | "RelatedContact" |"LandlordContact">
  parent: string
}

const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean, prefix: Props["prefix"]) => {
  ui[`${prefix}AsContact`] = checked
}

const ContactSwitch: React.FC<Props> = ({ prefix, parent }) => {
  const asContact = useAppSelector(({ ui }) => ui[`${prefix}AsContact`])
  const debugName = `[${parent}]▷[${name}]`

  useDebugInformation(debugName, {
    prefix,
    asContact
  })

  return (
    <Paper elevation={1} sx={{ p: .5, borderRadius: ".5rem", position: "relative", ml: ".8rem", my: 1 }}>
      <FormGroup row sx={{ mb: 0, pb: 0 }}>
        <FormControlLabel
          control={<Switch checked={asContact} onChange={React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleSwitchChange(event, checked, prefix), [prefix])} name={`AsContact`} color="primary" />}
          label="Same as customer"
          sx={{ zIndex: 10000, mb: 0, ml: 0 }}
        />
      </FormGroup>
    </Paper>
  );
}

export default React.memo(ContactSwitch)